import { AssessmentOverviewFormField } from '../sections/assessmentOverview/formField'
import { AuthorizationFormField } from '../sections/authorization/formField'
import { CertPeriodRecapFormField } from '../sections/certPeriodRecap/formField'
import { DischargePlanningFormField } from '../sections/dischargePlanning/formField'
import { FinalStepsFormField } from '../sections/finalSteps/formField'
import { MedicalBackgroundFormField } from '../sections/medicalBackground/formField'
import { MedicationsFormField } from '../sections/medications/formField'
import { NarrativeFormField } from '../sections/narrative/formField'
import { PlanOfCareFormField } from '../sections/planOfCare/formField'
import { SupervisoryReviewFormField } from '../sections/supervisoryReview/formField'
import { VisitSchedulingFormField } from '../sections/visitScheduling/formField'
import { VitalsFormField } from '../sections/vitals/formField'
import { SkilledNeedsFormField } from '../sections/skilledNeeds/formField'
import { ADLNeedFormField } from '../sections/adlNeeds/formField'

export const RecertFormField = {
  ...AssessmentOverviewFormField,
  ...AuthorizationFormField,
  ...CertPeriodRecapFormField,
  ...DischargePlanningFormField,
  ...FinalStepsFormField,
  ...MedicalBackgroundFormField,
  ...MedicationsFormField,
  ...NarrativeFormField,
  ...PlanOfCareFormField,
  ...SupervisoryReviewFormField,
  ...VisitSchedulingFormField,
  ...VitalsFormField,
  ...SkilledNeedsFormField,
  ...ADLNeedFormField
} as const

export type RecertFormField = (typeof RecertFormField)[keyof typeof RecertFormField]
